import { combineReducers } from 'redux'
import { entitiesCreators } from 'store/common'
import { REDUCER_NAME_ME } from 'utils/constants/store/reducersNames'

export const staticsNames = [REDUCER_NAME_ME]

export const staticsReducers = staticsNames
  .sort()
  .reduce((reducers, name) => ({ ...reducers, [name]: entitiesCreators.createStoreEntityStatic(name) }), {})

export default combineReducers(staticsReducers)
